import React from 'react';

/**
 * HighlightText Component
 * Highlights matching text within a string based on search query
 * 
 * @param {string} text - The full text to display
 * @param {string} highlight - The search query to highlight
 * @param {string} className - Optional CSS class for the container
 */
const HighlightText = ({ text, highlight, className = '' }) => {
  if (!highlight || !highlight.trim()) {
    return <span className={className}>{text}</span>;
  }

  if (!text) {
    return <span className={className}></span>;
  }

  // Escape special regex characters in the highlight string
  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };

  try {
    // Create a case-insensitive regex to find all matches
    const regex = new RegExp(`(${escapeRegExp(highlight)})`, 'gi');
    const parts = text.split(regex);

    return (
      <span className={className}>
        {parts.map((part, index) => {
          // Check if this part matches the highlight (case-insensitive)
          if (part.toLowerCase() === highlight.toLowerCase()) {
            return (
              <mark
                key={index}
                style={{
                  backgroundColor: '#FEF3C7',
                  color: '#92400E',
                  padding: '2px 4px',
                  borderRadius: '3px',
                  fontWeight: '500',
                }}
              >
                {part}
              </mark>
            );
          }
          return <span key={index}>{part}</span>;
        })}
      </span>
    );
  } catch (error) {
    return <span className={className}>{text}</span>;
  }
};

export default HighlightText;
